// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"77eaa884","455":"e7e98106"}[chunkId] + ".chunk.js";
};